import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core'
import { Validatable } from './validatable'
import { FormValidationService } from './form-validation-service'

@Component({
    selector: 'ValidatedTextField',
    templateUrl: './html-templates/validated-text-field.component.html'
})
export class ValidatedTextField extends Validatable<string> implements OnChanges {
    @Input() text = ''
    @Input() label = ''
    @Input() id = ''
    @Input() for = ''
    @Input() validationLabel: string
    @Input() type = 'text'
    @Input() helperText = ''
    @Input() maxlength = ''
    @Input() minlength = ''
    @Input() blurnotify: boolean = false
    @Input() requiredField: boolean = false
    @Input() errorMessages: string[] = []
    @Output() onValueChange: EventEmitter<string> = new EventEmitter<string>()
    @Output() blur: EventEmitter<string> = new EventEmitter<string>()
    
   // public uniqueId: string = ''
    constructor(formValidationService: FormValidationService) {
        super(formValidationService)
    }
    ngOnInit() {
        this.id = this.id + this.getId();   
    }
    onBlur() {
        this.blur.emit(this.text)

        this.validate()
    }

    getDescribedBy(): string | null {
        const ids: string[] = []
         if (this.helperText) {
             ids.push(`${this.id||this.for}-helper`);
         }
        if (this.errorMessages?.length > 0) {
            ids.push(`${this.id || this.for}-error`);
        }  
        return ids.length ? ids.join(' ') : null;
    }

    getLabel() {
        if (this.validationLabel) {
            return this.validationLabel
        } else {
            return this.label
        }
    }

    getId() {
        const timestamp = Date.now().toString(36)
        const randomStr = Math.random().toString(36).substring(2, 9)
        return `field-${timestamp}-${randomStr}`//return this.id
    }

    getValue() {
        return this.text
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.disabled && changes.disabled.currentValue) {
            this.clearValidationErrors()
        }

        if (changes.blurnotify !== undefined && !changes.blurnotify.firstChange) {
            this.onBlur()
        }
    }
    
    
}
